module.exports = __webpack_public_path__ + "img/ecoset.9caa1712.jpeg";